import PropTypes from "prop-types";
import { useComprasAuth } from "../../hooks/useComprasAuth";
import NoAccess from "../../../pages/no-access/index";

/**
 * Guarda de roles que verifica si el usuario tiene el rol requerido
 * antes de renderizar el contenido protegido.
 *
 * Si el usuario no tiene el rol requerido, se muestra la página de
 * acceso denegado con un enlace al Portal de Aplicaciones.
 *
 * @param {Object} props
 * @param {string} props.requiredRole - Rol requerido para acceder
 * @param {React.ReactNode} props.children - Contenido protegido
 * @param {React.ReactNode} [props.fallback] - Componente a mostrar si no tiene acceso
 */
const RoleGuard = ({ requiredRole, children, fallback = <NoAccess /> }) => {
    const { authenticated, loading, hasRealmRole, username } = useComprasAuth();

    // Mientras carga, no mostrar nada (AuthKeycloak ya maneja loading)
    if (loading || !authenticated) {
        return null;
    }

    // Verificar si tiene el rol requerido
    const hasAccess = hasRealmRole(requiredRole);

    // Si no tiene acceso, mostrar fallback
    if (!hasAccess) {
        console.warn(
            `[RoleGuard] Usuario ${username || "(desconocido)"} no tiene el rol: ${requiredRole}`
        );
        return fallback;
    }

    // Si tiene acceso, renderizar children
    return children;
};

RoleGuard.propTypes = {
    requiredRole: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    fallback: PropTypes.node,
};

export default RoleGuard;
